import Vue from 'vue'
import validate from 'mixins/validate'

export default el => Promise.all([
  enqueueModule('checkbox.vue'),
  enqueueModule('phone-input.vue')
]).then(() => new Vue({
  el,
  mixins: [validate],
  mounted () {
    this.setReturnTo()
  },
  methods: {
    setReturnTo () {
      const returnTo = this.$el.querySelector('[data-return-to]')

      if (!returnTo) return

      const url = new URL(window.location.href)
      url.searchParams.set('customer_posted', 'true')
      url.hash = returnTo.dataset.returnToHash || ''
      returnTo.value = `${url.pathname}${url.search}${url.hash}`
    },
    submitForm (event) {
      this.setReturnTo()

      let isValid = this.validateAndDisplayErrors()
      const phone = this.$refs.phone

      if (phone && typeof phone.normalizeBeforeSubmit === 'function') {
        const phoneValid = phone.normalizeBeforeSubmit()
        if (!phoneValid) isValid = false
      }

      if (!isValid) {
        event.preventDefault()
      }
    }
  }
}))
